module.exports = __webpack_public_path__ + "static/sg-logo.7ae2040f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brands/sg-logo.svg
// module id = 189
// module chunks = 35783957827783 246384609461072